module.exports = __webpack_public_path__ + "img/bulma-logo.32f397ff.png";